<template>
  <div>
    <div v-if="getPurchaseOrder.id !== undefined && getPurchaseOrder.id == id">
      <div class="row tile_count">
        <div class="col-md-4 col-sm-4 col-xs-6 tile_stats_count">
          <zee-purchase-order-id
            :is-internal="getIsInternal"
            :item="getPurchaseOrder"
            :updates="getUpdatesChanges"></zee-purchase-order-id>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-6 tile_stats_count">
          <span class="count_top"><i class="fa fa-clock-o"></i> Status</span>
          <div class="count green">
            {{ getIsInternal && getPurchaseOrder.status === 'Shipped' ?
            'Delivered' : getPurchaseOrder.status }}
          </div>
          <span
            class="count_bottom"
            v-if="getPurchaseOrder.status == 'Created'">
            Created at {{ getPurchaseOrder.created | moment('DD/MM/YYYY') }}
          </span>
          <span
            class="count_bottom"
            v-if="getPurchaseOrder.status ==
          'In Production' && getPurchaseOrder.statusInProductionAt">
            Updated at {{ getPurchaseOrder.statusInProductionAt | moment('DD/MM/YYYY') }}
          </span>
          <span
            class="count_bottom"
            v-if="getPurchaseOrder.status ==
          'Handed Over' && getPurchaseOrder.statusHandedOverAt">
          Updated at {{ getPurchaseOrder.statusHandedOverAt | moment('DD/MM/YYYY') }}</span>
          <span
            class="count_bottom"
            v-if="getPurchaseOrder.status ==
          'Shipped' && getPurchaseOrder.statusShippedAt">
          Updated at {{ getPurchaseOrder.statusShippedAt | moment('DD/MM/YYYY') }}</span>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-6 tile_stats_count">
          <span class="count_top"><i class="fa fa-usd"></i> Total Amount</span>
          <div class="count">{{ getPurchaseOrder.amount | currency }}</div>
          <span class="count_bottom">Total paid: {{ getTotalPaid | currency }}</span>
        </div>
        <div class="col-md-2 col-sm-2 col-xs-6 tile_stats_count">
          <span class="count_top"><i class="fa fa-usd"></i> Payment Status</span>
          <div
            class="count"
            :class="getPaymentStatus ? 'green' : 'warning' ">
          {{ getPaymentStatus ? 'Paid' : 'Pending' }}</div>
        </div>
      </div>
      <zee-po-timeline
        v-if="!getIsInternal"
        :item="getPurchaseOrder"
        :updates="getUpdatesChanges" ></zee-po-timeline>
      <zee-po-internal-timeline
        v-else
        :item="getPurchaseOrder"
        :updates="getUpdatesChanges"></zee-po-internal-timeline>
      <div class="x_content">
        <el-tabs
          type="border-card"
          @tab-click="sendTabInfo"
          :value="getActiveTab">
          <el-tab-pane
            id="po"
            name="po">
            <span slot="label">
              Informations
              <span
                v-once
                ref="notification-po"
                class="tab-updates tab-updates--info"
                v-if="getUpdates && getUpdates.tabs.po > 0">
                {{ getUpdates.tabs.po }}
              </span>
            </span>
            <div class="row">
              <zee-po-supplier
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-supplier>
              <zee-po-destination
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-destination>
            </div>
            <div class="row">
              <zee-po-estimated-date
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-estimated-date>
              <zee-po-handed-over-date
                v-if="!getIsInternal"
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-handed-over-date>
              <zee-po-shipped-date
                v-if="getIsInternal"
                :is-internal="getIsInternal"
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-shipped-date>
            </div>
            <div
              class="row"
              v-if="!getIsInternal">
              <zee-po-shipped-date
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-shipped-date>
            </div>
          </el-tab-pane>
          <el-tab-pane
            id="payments"
            name="payments">
            <span slot="label">
              Payments
              <span
                v-once
                ref="notification-payments"
                class="tab-updates tab-updates--payments"
                v-if="getUpdates && getUpdates.tabs.payments > 0">
                {{ getUpdates.tabs.payments }}
              </span>
            </span>
            <zee-po-payment-summary
              :item="getPurchaseOrder"
              :updates="getUpdatesChanges"></zee-po-payment-summary>
          </el-tab-pane>
          <el-tab-pane
            id="products"
            name="products">
            <span slot="label">
              Products
              <span
                v-once
                ref="notification-products"
                class="tab-updates tab-updates--products"
                v-if="getUpdates && getUpdates.tabs.products > 0">
                {{ getUpdates.tabs.products }}
              </span>
            </span>
            <div class="row">
              <zee-po-products
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-products>
            </div>
          </el-tab-pane>
          <el-tab-pane
            id="comments"
            name="comments">
            <span slot="label">
              Comments
              <span
                v-once
                ref="notification-comments"
                class="tab-updates tab-updates--comments"
                v-if="getUpdates && getUpdates.tabs.comments > 0">
                {{ getUpdates.tabs.comments }}
              </span>
            </span>
            <div class="row">
              <zee-po-comments
                :item="getPurchaseOrder"
                :updates="getUpdatesChanges"></zee-po-comments>
            </div>
          </el-tab-pane>
          <el-tab-pane
            id="documents"
            name="documents">
            <span slot="label">
              Documents
              <span
                v-once
                ref="notification-documents"
                class="tab-updates tab-updates--documents"
                v-if="getUpdates && getUpdates.tabs.documents > 0">
                {{ getUpdates.tabs.documents }}
              </span>
            </span>
            <zee-po-documents
              :item="getPurchaseOrder"
              :updates="getUpdatesChanges"></zee-po-documents>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div
      class="full-height"
      v-else
      v-loading="isLoading"
      element-loading-text="Loading...">
    </div>
  </div>
</template>
<script>
import zeePoTimeline from './partials/PoTimeline.vue';
import zeePoInternalTimeline from './partials/PoInternalTimeline.vue';
import zeePoSupplier from './partials/PoSupplier.vue';
import zeePoDestination from './partials/PoDestination.vue';
import zeePoForWho from './partials/PoForWho.vue';
import zeePoEstimatedDate from './partials/PoEstimatedDate.vue';
import zeePoHandedOverDate from './partials/PoHandedOverDate.vue';
import zeePoShippedDate from './partials/PoShippedDate.vue';
import zeePoRecentAct from './partials/PoRecentAct.vue';
import zeePoPaymentSummary from './partials/PoPaymentSummary.vue';
import zeePoProducts from './partials/PoProducts.vue';
import zeePoComments from './partials/PoComments.vue';
import zeePoDocuments from './partials/PoDocuments.vue';
import zeePurchaseOrderId from './partials/PoID.vue';

export default {
  components: {
    zeePoTimeline,
    zeePoSupplier,
    zeePoDestination,
    zeePoForWho,
    zeePoEstimatedDate,
    zeePoHandedOverDate,
    zeePoShippedDate,
    zeePoRecentAct,
    zeePoPaymentSummary,
    zeePoProducts,
    zeePoComments,
    zeePoDocuments,
    zeePurchaseOrderId,
    zeePoInternalTimeline,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  beforeMount() {
    document.querySelector('body').className = 'is-po';
  },
  data() {
    return {
      poId: this.id,
      purchaseOrder: {},
      updatePOFormVisible: false,
      isUploading: false,
      fileList: [],
      isLoading: true,
      activeTab: 'po',
    };
  },
  computed: {
    getPurchaseOrder() {
      return this.$store.getters.getPOItem;
    },
    getUpdatesChanges() {
      return this.$store.getters.getPOUpdates;
    },
    getUpdates() {
      return this.$store.getters.getUpdates;
    },
    getTotalProducts() {
      let counter = 0;
      for (let j = 0; j < this.getPurchaseOrder.products.length; j += 1) {
        counter += this.getPurchaseOrder.products[j].quantity;
      }
      return counter;
    },
    getIsInternal() {
      return this.getPurchaseOrder.isInternal;
    },
    getPaymentStatus() {
      if (this.getPurchaseOrder.payment.status === 'paid') {
        return true;
      }
      return false;
    },
    getTotalPaid() {
      let paymentsTotal = 0;
      for (let i = 0; i < this.getPurchaseOrder.payment.payments.length; i += 1) {
        if (
          this.getPurchaseOrder.payment.payments[i].isCompleted &&
          this.getPurchaseOrder.payment.payments[i].acknowledgement
        ) {
          paymentsTotal += parseInt(this.getPurchaseOrder.payment.payments[i].amount, 10);
        }
      }
      return paymentsTotal;
    },
    getActiveTab() {
      if (this.$route.query.tab) {
        const queryTab = this.$route.query.tab;
        this.changeActiveTab(queryTab);
        return this.$route.query.tab;
      }
      return 'po';
    },
  },
  created() {
    return this.$store.dispatch('setPOItem', {
      id: this.id,
      tabInfo: `?tab=${this.getActiveTab}`,
    });
  },
  methods: {
    changeActiveTab(t) {
      this.activeTab = t;
    },
    submitUpload() {
      this.isUploading = true;
      return this.$refs.upload.submit();
    },
    uploadError() {
      this.isUploading = false;
      return this.$message.error('Something went wrong. Try again.');
    },
    uploadSucess() {
      this.isUploading = false;
      this.updatePOFormVisible = false;
      return this.$message({
        message: 'Success! PO updated.',
        type: 'success',
      });
    },
    sendTabInfo(tab) {
      if (typeof this.$refs[`notification-${this.activeTab}`] !== 'undefined') {
        this.$refs[`notification-${this.activeTab}`].remove();
      }
      this.activeTab = tab.$el.id;
      const activeTabObj = {
        id: this.id,
        name: this.activeTab,
      };
      return this.$store.dispatch('sendActiveTab', activeTabObj);
    },
  },
};
</script>

<style lang="scss" scoped>
.count {
  &.success {
    color: #5cb85c;
  }
  &.warning {
    color: #f0ad4e;
  }
}
.el-upload {
  width: 100%;
}
.full-height {
  height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/PoDetails.vue